var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "subscription-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.-Company->-Reactivate",
    transform: "translate(-299.000000, -201.000000)",
    fill: "#FECB48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.545455,201 C313.796705,201 314,201.203302 314,201.454545 L314,216.752728 C314,217.003092 313.796698,217.207273 313.545455,217.207273 L310.818182,217.207273 L310.818182,220.545455 C310.818182,220.795818 310.61488,221 310.363637,221 L299.454545,221 C299.203295,221 299,220.795809 299,220.545455 L299,205.247273 C299,204.996023 299.203302,204.792727 299.454545,204.792727 L302.181818,204.792727 L302.181818,201.454545 C302.181818,201.203295 302.385121,201 302.636364,201 L313.545455,201 Z M309.909091,205.701818 L299.909091,205.701818 L299.909091,220.09091 L309.909091,220.09091 L309.909091,205.701818 Z",
    id: "subscription-icon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.09a5bfbc1ad37b7647255dc32bea1e0b.svg";
export { ForwardRef as ReactComponent };